import { Box, Typography } from '@mui/material';
import { ChevronRight } from 'lucide-react';
import { HAIRLINE } from '../colors';
import { PaymentWithTransfers } from '../../../../types/payments';
import { PAYMENTS_GRID_COLUMNS } from './tabTableLayout';
import {
  describePaymentRow,
  PaymentRowStatusColor,
} from './helpers/paymentRowContent';

interface Props {
  payment: PaymentWithTransfers;
  timezone: string;
  onSelect: (payment: PaymentWithTransfers) => void;
}

const STATUS_COLOR: Record<PaymentRowStatusColor, string> = {
  success: 'success.main',
  muted: 'text.secondary',
  danger: 'error.main',
};

function PaymentTableRow({ payment, timezone, onSelect }: Props) {
  const content = describePaymentRow(payment, timezone);

  return (
    <Box
      onClick={() => onSelect(payment)}
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: PAYMENTS_GRID_COLUMNS },
        columnGap: '20px',
        rowGap: { xs: '6px', sm: 0 },
        alignItems: 'center',
        padding: '18px 0',
        borderBottom: `1px solid ${HAIRLINE}`,
        cursor: 'pointer',
      }}>
      <Box>
        <Typography variant="h4" sx={{ color: 'text.primary' }}>
          {content.description}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', marginTop: '5px' }}>
          {content.metaLine}
        </Typography>
      </Box>
      <Typography
        variant="h5"
        sx={{ color: STATUS_COLOR[content.statusDisplay.color] }}>
        {content.statusDisplay.label}
      </Typography>
      <Box sx={{ display: { xs: 'none', sm: 'flex' }, color: 'text.disabled' }}>
        <ChevronRight size={18} strokeWidth={2} color="currentColor" />
      </Box>
    </Box>
  );
}

export default PaymentTableRow;
